import React from 'react';
import DatePicker from "react-datepicker2";

export default function DatePickerComponent({ icon, onChange, value, className }) {
    return (
        <div className={`date-picker ${className ? className : ''}`}>
            {
                icon &&
                <div className='icon'>
                    {icon}
                </div>
            }
            <div className='element'>
                <DatePicker
                    onChange={onChange}
                    value={value}
                    timePicker={false}
                    isGregorian={false}
                    inputReadOnly={true}
                />
            </div>
        </div>
    );
};